import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import styles from './Layout.module.css';
import Sidebar from './Sidebar';
import DashboardPage from '../pages/DashboardPage';
import BranchesPage from '../pages/BranchesPage';
import DepartmentsPage from '../pages/DepartmentsPage';
import DoctorsPage from '../pages/DoctorsPage';
import SlotsPage from '../pages/SlotsPage';
import AppointmentsPage from '../pages/AppointmentsPage';
import BookAppointmentPage from '../pages/BookAppointmentPage';
import PatientsPage from '../pages/PatientsPage';
import PatientDetailPage from '../pages/PatientDetailPage';
import UserManagementPage from '../pages/UserManagementPage';

export default function Layout({ onLogout }) {
  return (
    <div className={styles.container}>
      <Sidebar />
      <main className={styles.main}>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/branches" element={<BranchesPage />} />
          <Route path="/departments" element={<DepartmentsPage />} />
          <Route path="/doctors" element={<DoctorsPage />} />
          <Route path="/slots" element={<SlotsPage />} />
          <Route path="/book-appointment" element={<BookAppointmentPage />} />
          <Route path="/appointments" element={<AppointmentsPage />} />
          <Route path="/patients" element={<PatientsPage />} />
          <Route path="/patients/:id" element={<PatientDetailPage />} />
          <Route path="/users" element={<UserManagementPage />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </main>
    </div>
  );
}
